import { render, staticRenderFns } from "./PcHeartbeat.vue?vue&type=template&id=9a3171e0&"
import script from "./PcHeartbeat.vue?vue&type=script&lang=js&"
export * from "./PcHeartbeat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports